import '../Styles/StudiesPage.css';
import React,{useState,useEffect} from "react"
import { getAllStudies } from '../Services/services'
import Loading from '../Components/Loading';
import Diploma from '../Components/Diploma';

function StudiesPage(props) {

    const [studies,setStudies] = useState([]);
    const [loading,setLoading] = useState(true);
  
    useEffect(
      ()=>{
        const request = async ()=>{
            try {
                const response = await getAllStudies()
                console.log(response)
                setStudies(response)
                setLoading(false)
            } catch(e) {
                console.log(e)
                setLoading(false)
            }
        }
        request()
      },[]
    )

    if (loading) {
        return <Loading />
    } else {
        return (
        <main className="StudiesPage">
            {studies.map(studiesData =>
                <Diploma data={studiesData.data()} key={studiesData.id} id={studiesData.id} language={props.language} uk={props.uk} />
            )}
        </main>
        );
    }
}

export default StudiesPage;